import React from "react";
import { Link } from "react-router-dom";
import { ClockIcon, FacebookIcon, MapPinIcon, PhoneIcon } from "lucide-react";
import { business, navLinks, quickLinks } from "../../data/business";
import { trustBadges } from "../../data/home";
import { Logo } from "../brand/Logo";
import { TrustBadge } from "../brand/TrustBadge";
export function Footer() {
  const heading = "eyebrow text-gold-soft";
  const link = "text-white/75 transition-colors duration-150 hover:text-gold-soft";
  return <footer className="grain bg-navy-900 text-white" data-id="element-321" data-mp="3s259a3l1j3ds">
      <div className="gutter pb-10 pt-[clamp(4rem,7vw,7rem)]" data-id="element-322" data-mp="3s0kfwhagpqhi">
        <div className="grid gap-12 md:grid-cols-2 xl:grid-cols-[1.4fr_0.8fr_0.9fr_1.4fr] 3xl:grid-cols-[1.4fr_0.7fr_0.8fr_1.8fr]" data-id="element-323" data-mp="3n4lvt5w62umw">
          <div data-id="element-324" data-mp="3j3tk85ztodng">
            <Logo data-id="element-325" data-mp="3j05t1dhuo3bw" />
            <p className="measure mt-6 max-w-sm text-white/70" data-id="element-326" data-mp="3e2mcg6xojegs">
              A locally owned, veteran-owned Las Vegas bail bond agency helping families with dignity, privacy, and calm since 2011.
            </p>
            <ul className="mt-8 grid max-w-md gap-4 sm:grid-cols-2" data-id="element-327" data-mp="2kcuv111eh13z">
              {trustBadges.slice(0, 4).map(b => <li key={b.key} data-id="element-328" data-mp="2p4mobjbxxkxt">
                  <TrustBadge badgeKey={b.key} label={b.label} tone="dark" data-id="element-329" data-mp="2p5o1btciohi6" />
                </li>)}
            </ul>
          </div>

          <nav aria-label="Footer pages" data-id="element-330" data-mp="2gaq1e2ayc4hc">
            <h2 className={heading} data-id="element-331" data-mp="2g9f1weojhiw1">Pages</h2>
            <ul className="mt-5 space-y-3" data-id="element-332" data-mp="340kdghng5p0j">
              {navLinks.map(l => <li key={l.to} data-id="element-333" data-mp="382fedl1gu0ds">
                  <Link to={l.to} className={link} data-id="element-334" data-mp="381nsj1xo7h0p">
                    {l.label}
                  </Link>
                </li>)}
              <li data-id="element-335" data-mp="2u5aczycp5pov">
                <Link to="/blog/" className={link} data-id="element-336" data-mp="2z1r0qrfzi21f">
                  The Bond Blog
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Quick links" data-id="element-337" data-mp="1img05pizpkra">
            <h2 className={heading} data-id="element-338" data-mp="1nmkkjqn0qzms">Quick Links</h2>
            <ul className="mt-5 space-y-3" data-id="element-339" data-mp="1nof4b1mk0lpa">
              {quickLinks.map(l => <li key={l.to} data-id="element-340" data-mp="13jfzx06kezx8">
                  <Link to={l.to} className={link} data-id="element-341" data-mp="13mu50g6m5n8d">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-342" data-mp="uquvkp3okvrx">
            <h2 className={heading} data-id="element-343" data-mp="uqbbp2ugzxb9">Contact</h2>
            <ul className="mt-5 space-y-4" data-id="element-344" data-mp="pu4epzk1xw5g">
              <li data-id="element-345" data-mp="pt2sr01hzp8y">
                <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className={`flex gap-3 ${link}`} data-id="element-346" data-mp="pri57udlp6kl">
                  <MapPinIcon className="mt-1 h-4 w-4 shrink-0 text-gold-soft" strokeWidth={1.5} aria-hidden="true" data-id="element-347" data-mp="fvey0a3w6hqs" />
                  <span data-id="element-348" data-mp="bss1vx06uans">
                    {business.street}
                    <br data-id="element-349" data-mp="6ugq3gqc1q2x" />
                    {business.cityLine}
                  </span>
                </a>
              </li>
              <li data-id="element-350" data-mp="267ul5cyn8wi9">
                <a href={business.phoneHref} className="flex items-center gap-3 font-serif text-2xl text-gold-soft transition-colors duration-150 hover:text-gold" data-id="element-351" data-mp="2669qlncbxdke">
                  <PhoneIcon className="h-4 w-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-352" data-mp="28saili7ihc99" />
                  {business.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/75" data-id="element-353" data-mp="2dor4s6v5hgjp">
                <ClockIcon className="h-4 w-4 shrink-0 text-gold-soft" strokeWidth={1.5} aria-hidden="true" data-id="element-354" data-mp="2iic3k14kiejy" />
                Open 24/7 — 365 days a year
              </li>
              <li data-id="element-355" data-mp="1pty1naacyy34">
                <a href={business.facebookUrl} target="_blank" rel="noopener noreferrer" className={`flex items-center gap-3 ${link}`} data-id="element-356" data-mp="1puppfyxprriu">
                  <FacebookIcon className="h-4 w-4 shrink-0 text-gold-soft" strokeWidth={1.5} aria-hidden="true" data-id="element-357" data-mp="1uu2kh6yqo4wi" />
                  Follow us on Facebook
                </a>
              </li>
            </ul>
            <div className="mt-6 overflow-hidden rounded-2xl border border-gold/25" data-id="element-358" data-mp="3b6hpgr7cy9ld">
              <iframe title="Map to Post Bail Bonds Inc., 2917 S Sammy Davis Jr Dr, Las Vegas" src={business.mapsEmbed} className="block h-48 w-full grayscale-[40%] 3xl:h-56" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-359" data-mp="3b8u3it9zvzt5" />
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-gold/25 pt-8 text-sm text-white/60" data-id="element-360" data-mp="3nqep33w9ql3l">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between" data-id="element-361" data-mp="3ip7iv99rxtz1">
            <p data-id="element-362" data-mp="j2vaz0gpt6v">
              © 2011–2026 Post Bail Bonds Inc. · Licensed by the Nevada Division of Insurance · Lic. # {business.license}
            </p>
            <p className="flex gap-5" data-id="element-363" data-mp="aa775puucxxh">
              <a href="#privacy" className="hover:text-gold-soft" data-id="element-364" data-mp="a95op0bhx95q">Privacy Policy</a>
              <a href="#terms" className="hover:text-gold-soft" data-id="element-365" data-mp="5audom9gsslx">Terms</a>
            </p>
          </div>
          <p className="measure mt-4 text-white/50" data-id="element-366" data-mp="ja3p78mq6yjk">
            Post Bail Bonds is not a law firm and does not provide legal advice. Links to government resources are provided for convenience.
          </p>
        </div>
      </div>
    </footer>;
}